exports.connect = {
	url: "https://api.versants.camp/"
}
